import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { currentBoxesQuantityErrorSelector, currentBoxesQuantitySelector, minQuantitySelector, isAddonStepRestrictedSelector, isDisableBoxBuilderNextButtonSelector, isEditBoxBuilderItemsIdSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { changeCurrentBoxesQuantity, saveSelectedCartItemsToBox } from '../../../../../redux/box-builder/box-builder.actions';
import { SelectCartItemsHeaderComponent } from './select-cart-items-header';
const mapStateToProps = createStructuredSelector({
  isEditMode: isEditBoxBuilderItemsIdSelector,
  isDisableNextButton: isDisableBoxBuilderNextButtonSelector,
  minQuantity: minQuantitySelector,
  currentBoxesQuantity: currentBoxesQuantitySelector,
  currentBoxesQuantityError: currentBoxesQuantityErrorSelector,
  isAddonStepRestricted: isAddonStepRestrictedSelector
});
const mapDispatchToProps = dispatch => ({
  onChangeQuantity: quantity => {
    dispatch(changeCurrentBoxesQuantity(quantity));
  },
  onNextClick: () => {
    dispatch(saveSelectedCartItemsToBox());
  }
});
export const SelectCartItemsHeader = connect(mapStateToProps, mapDispatchToProps)(SelectCartItemsHeaderComponent);